module.exports = __webpack_public_path__ + "static/media/logo.5bbef149.svg";